var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentLinkOffOutlineOpt2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.04 9.89L4.93 12A5 5 0 0012 19.07l2.111-2.11 5.69 5.69 1.4-1.4L2.8 2.85l-1.4 1.4 5.64 5.64zm1.414 1.413l1.414 1.415-2.11 2.11 1.414 1.415 2.11-2.111 1.415 1.414-2.11 2.11a3 3 0 11-4.243-4.242l2.11-2.11z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.657 6.343a3 3 0 00-4.243 0l-2.12 2.121L9.878 7.05 12 4.928A5 5 0 0119.071 12l-2.121 2.122-1.414-1.414 2.121-2.122a3 3 0 000-4.242z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.829 7.757l-2.11 2.11 1.414 1.415 2.11-2.11-1.414-1.415z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentLinkOffOutlineOpt2);
export default __webpack_public_path__ + "2f599be92f797051a80e3b98bf8c5aac.svg";
export { ForwardRef as ReactComponent };